import React from 'react';

import { Column, ColumnProps } from '../Grid/Column';

export const Content: React.FC<ColumnProps> = props => <Column as="main" width={12} className="pad-m" {...props} />;
